import { render, staticRenderFns } from "./ManageVenueDetails.vue?vue&type=template&id=b846d986&scoped=true"
import script from "./ManageVenueDetails.vue?vue&type=script&lang=js"
export * from "./ManageVenueDetails.vue?vue&type=script&lang=js"
import style0 from "./ManageVenueDetails.vue?vue&type=style&index=0&id=b846d986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b846d986",
  null
  
)

export default component.exports